module.exports = __webpack_public_path__ + "static/media/atendimento.c2090112.svg";